import Vue from "vue";

export function initVueVariables(config) {
    Vue.prototype.$_name = config.name;
    Vue.prototype.$_apiName = config.apiName;
    Vue.prototype.$_domain = config.domain;
    Vue.prototype.$_ymId = config.ymId;
    Vue.prototype.$_myTarget = config.myTarget || {};
    Vue.prototype.$_url = config.urlApi; //Vue.config.productionTip ? "prod" : "dev";
}
